import styled from 'styled-components';

export const Container = styled.section`
  font-family: 'Work Sans', Arial, Helvetica, sans-serif;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  & > header {
    padding: 1.5rem;
    background-color: ${({ theme }) => theme.colors.white};

    & > div {
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        max-width: ${({ theme }) => theme.breakpoints.laptopL};
      }
    }

    & > .hefesto-title > h1 {
      font-weight: 600;
      margin-bottom: 1rem;
      font-size: 48px;

      font-family: 'Source Sans 3', 'Source Sans Pro', Arial, Helvetica;
      color: ${({ theme }) => theme.colors.grayDark3};
    }

    & > span {
      font-size: 1rem;
      letter-spacing: 0.1px;
      color: ${({ theme }) => theme.colors.grayDark4};
      & > h1 {
        margin-bottom: 1rem;
      }
    }
  }

  & .cards {
    width: 100%;
    padding: 1.5rem 0;
    background-color: #fff;

    & > .subtitle-cards {
      margin: 1.5rem;
      margin-top: 0;

      & > .hefesto-title > h2 {
        font-size: 2rem;
        font-family: 'Source Sans 3', 'Source Sans Pro', Arial, Helvetica;
        color: ${({ theme }) => theme.colors.grayDark3};
      }
    }
  }
`;

export const CardsContainer = styled.div<{ disabledButtons?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  row-gap: 1rem;
  column-gap: 1.5rem;

  padding-left: 1.5rem;

  & .cards-container:last-child {
    column-gap: 0;
  }

  & > .card {
    width: 100%;
    min-height: 15rem;
    max-width: 16.875rem;

    border: 1px solid #dee8ef;
    border-radius: 8px;

    & > .hefesto-card {
      height: 100%;

      & > .hefesto-card-text-buttons {
        display: flex;
        flex-direction: column;
        height: 100%;

        & > .hefesto-title {
          margin-right: 0.5rem;
          margin-bottom: 0.313rem;
          & > h4 {
            margin: 0px;
            font-weight: 550;
            color: ${({ theme }) => theme.colors.grayDark3};
          }
        }
        & > .hefesto-card-text-buttons__description {
          flex-grow: 1;
          margin-top: 0rem;
        }
        & > .hefesto-card-text-buttons__actions {
          & > .hefesto-button {
            padding-inline: 0px;
            ${({ disabledButtons }) =>
              disabledButtons &&
              `
                opacity: 36%;
                cursor: not-allowed;
              `};
          }
        }
      }
    }
  }

  p {
    min-height: 75px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: ${({ theme }) => theme.breakpoints.laptopL};

    & > .card {
      max-width: 94%;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-wrap: nowrap;
    column-gap: 1.5rem;

    & > .card {
      width: 50%;
    }
  }
`;

export const EmitterReceiverContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 2rem;

  > span {
    padding: 0 0 1rem 1.5rem;
    display: inline-block;
    color: ${({ theme }) => theme.colors.grayDark4};
  }
`;
